import store from "@frameworks/web/redux/store";
import { INDEX_DETAILS, INDEX_DETAILS_ERROR, INDEX_DETAILS_HIDE_ERROR, INDEX_DETAILS_START_LOADER, INDEX_DETAILS_STOP_LOADER, STREAM_INDEX_DETAILS, } from "../interface/IIndexDetails";
class IndexDetailsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    updateStream(stream) {
        this.dispatch({
            type: STREAM_INDEX_DETAILS,
            payload: { streamData: stream },
        });
    }
    getIndexDetails(data) {
        this.dispatch({
            type: INDEX_DETAILS,
            payload: { data },
        });
    }
    setError(payload) {
        this.dispatch({
            type: INDEX_DETAILS_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError() {
        this.dispatch({
            type: INDEX_DETAILS_HIDE_ERROR,
        });
    }
    startLoader() {
        this.dispatch({
            type: INDEX_DETAILS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: INDEX_DETAILS_STOP_LOADER,
        });
    }
}
export default IndexDetailsActions;
